import { Component, Input, OnInit } from '@angular/core';
import { SlotModel } from '../../../models/slot.model';
import { AuthStateService } from '../../../services/auth-state.service';
import { faStreetView, faUsers } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-agenda-participant-icons',
  templateUrl: './agenda-participant-icons.component.html',
  styleUrls: ['./agenda-participant-icons.component.scss']
})
export class AgendaParticipantIconsComponent implements OnInit {

  @Input() slot: SlotModel = null;
  @Input() mode: string = null;

  public faStreetView = faStreetView;
  public faUsers = faUsers;

  constructor(
    public auth: AuthStateService
  ) { }

  ngOnInit(): void {
  }

}
